import { QueryClient } from '@tanstack/react-query'
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 0,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5,
        },
    },
})
